import React, { memo } from 'react';

const RadiologyViewerInfo = memo(({ sliceIndex, totalSlices, windowWidth, windowCenter, currentSlice, voiRange }) => {
  // Support both direct props and the wrapped object format
  const sliceToShow = typeof sliceIndex !== 'undefined' ? sliceIndex : currentSlice;
  const totalSlicesToShow = totalSlices || 0;
  
  // Handle different ways window/level data can be passed
  let ww = windowWidth;
  let wc = windowCenter;
  
  if (voiRange) {
    ww = voiRange.windowWidth;
    wc = voiRange.windowCenter;
  }
  
  // Safely convert to numbers and round if they exist
  const formattedWW = typeof ww === 'number' && !isNaN(ww) ? Math.round(ww) : 0;
  const formattedWC = typeof wc === 'number' && !isNaN(wc) ? Math.round(wc) : 0;
  
  return (
    <div
      style={{
        position: 'absolute',
        bottom: '15px',
        left: '15px',
        zIndex: 10,
        color: '#39FF14', // Changed to green
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        padding: '5px', // Reduced padding
        borderRadius: '4px',
        fontFamily: 'monospace',
        fontSize: '12px', // Smaller font size
      }}
    >
      {/* Display is 1-based (slice 1..N); internal indices stay 0-based. */}
      <div>{totalSlicesToShow ? (sliceToShow || 0) + 1 : 0} / {totalSlicesToShow}</div>
      <div>W: {formattedWW} / L: {formattedWC}</div>
    </div>
  );
});

export default RadiologyViewerInfo;
